import { EVENTS } from 'src/constants/webSocketConsts/events';
import { loadKnowledgeBaseSettings } from 'src/store/knowledgeBase/actions';

/**
 *
 * @param event websocket event type for message
 * @param items an array of knowledge base settings entities (but should always have just one entity)
 */
const KnowledgeBaseSettingsHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
    case EVENTS.MODIFY:
      return loadKnowledgeBaseSettings(items[0]); // should always have just a single entity
    default:
      break;
  }
  return null;
};

export default KnowledgeBaseSettingsHandler;
